import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navLinks } from '../data/siteData';
import { useScrollY } from '../hooks/useAnimations';
import logo from '../assets/images/logo.webp';
import { FiMenu, FiX, FiPhone } from 'react-icons/fi';

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  const scrollY = useScrollY();
  const isHome = loc.pathname === '/';
  const solid = scrollY > 50 || !isHome;
  const textC = solid ? 'var(--navy)' : '#fff';

  useEffect(() => { setOpen(false); window.scrollTo(0, 0); }, [loc]);

  return (
    <>
      <nav style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
        background: solid ? 'rgba(255,255,255,0.97)' : 'transparent',
        backdropFilter: solid ? 'blur(14px)' : 'none',
        boxShadow: solid ? '0 1px 16px rgba(0,0,0,0.05)' : 'none',
        transition: 'all 0.35s ease', padding: solid ? '4px 0' : '10px 0',
      }}>
        <div className="container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <img src={logo} alt="" style={{ height: solid ? 44 : 54, transition: 'height 0.3s' }} />
            <div>
              <div style={{ fontFamily: 'var(--fh)', fontWeight: 800, fontSize: solid ? '0.9rem' : '1.05rem', color: textC, transition: 'all 0.3s', lineHeight: 1 }}>FINLAND</div>
              <div style={{ fontSize: '0.55rem', fontWeight: 700, color: 'var(--gold)', letterSpacing: '2.5px', marginTop: 2 }}>EARLY YEARS</div>
            </div>
          </Link>

          {/* Desktop */}
          <div className="hide-mob" style={{ display: 'flex', alignItems: 'center', gap: 22 }}>
            {navLinks.map(l => (
              <Link key={l.path} to={l.path} style={{
                color: loc.pathname === l.path ? 'var(--gold)' : textC,
                fontSize: '0.78rem', fontWeight: 600, letterSpacing: '0.3px', textTransform: 'uppercase',
                transition: 'color 0.3s', padding: '4px 0',
                borderBottom: loc.pathname === l.path ? '2px solid var(--gold)' : '2px solid transparent',
              }}>{l.label}</Link>
            ))}
            <Link to="/admissions" className="btn btn-gold" style={{ padding: '9px 22px', fontSize: '0.74rem' }}>Enrol Now</Link>
          </div>

          {/* Mobile toggle */}
          <button className="show-mob" onClick={() => setOpen(!open)} style={{
            display: 'none', background: 'none', border: 'none', cursor: 'pointer', color: textC, fontSize: '1.5rem', padding: 8,
          }}>
            {open ? <FiX /> : <FiMenu />}
          </button>
        </div>

        {/* Mobile menu */}
        {open && (
          <div style={{
            background: 'var(--white)', padding: '16px 24px 24px',
            boxShadow: '0 12px 36px rgba(0,0,0,0.08)', animation: 'fadeUp 0.25s ease',
          }}>
            {navLinks.map(l => (
              <Link key={l.path} to={l.path} style={{
                display: 'block', padding: '10px 0', color: loc.pathname === l.path ? 'var(--gold)' : 'var(--navy)',
                fontWeight: 600, textTransform: 'uppercase', fontSize: '0.88rem', borderBottom: '1px solid #f0f0f0',
              }}>{l.label}</Link>
            ))}
            <Link to="/admissions" className="btn btn-gold btn-full" style={{ marginTop: 16, padding: '12px 0' }}>Enrol Now</Link>
          </div>
        )}
      </nav>

      {/* Floating phone button */}
      <a href="tel:+919800000000" style={{
        position: 'fixed', bottom: 24, right: 24, zIndex: 999,
        width: 56, height: 56, borderRadius: '50%', background: 'var(--gold)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        boxShadow: '0 4px 20px rgba(232,168,56,0.4)', color: 'var(--navy)', fontSize: '1.3rem',
        animation: 'pulse 2s ease-in-out infinite',
      }}>
        <FiPhone />
      </a>
    </>
  );
};

export default Navbar;
